export default __webpack_public_path__ + "static/media/cme.6be741c3.gif";